import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = 'left',
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-3 md:gap-4 mb-6 md:mb-8 ${
        align === 'center'
          ? 'items-center text-center'
          : 'sm:flex-row sm:items-end sm:justify-between'
      }`}
    >
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs tracking-wide text-primary-700 bg-primary-50 border border-primary-200 px-2.5 py-1 rounded-full">
            <i className="ri-bookmark-3-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{description}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="shrink-0 inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}